<mds-dialog dialogTitle="Site Status">
    <mds-dialog-content [formGroup]="siteStatusChangeFormGroup">
        <div class="o-grid">
            @if (statusText$ | async; as statusName) {
                <div class="o-grid__row">
                    <div class="o-grid__item">
                        <div class="c-info__block">
                            <h5>Current Status</h5>
                            <span>{{ statusName }}</span>
                        </div>
                    </div>
                </div>
            }
            @if (availableActions$ | async; as options) {
                <div class="o-grid__row">
                    <div class="o-grid__field">
                        <mds-dropdown
                            [closeOnPageScroll]="false"
                            [formCtrl]="siteStatusChangeFormGroup.controls.statusDropdownControl"
                            appearance="outline"
                            label="Change Status to"
                            placeholder="Please Select Status"
                            [options]="options"
                            id="siteStatusDropdown"
                            [required]="true"
                        ></mds-dropdown>
                    </div>
                </div>
            } @else {
                <div class="spinnerOverlay">
                    <medpace-loading-card></medpace-loading-card>
                </div>
            }
        </div>
    </mds-dialog-content>
    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            <mds-button [id]="'cancel-btn'" label="Cancel" (clickEvent)="closeDialog()" variant="outline"> </mds-button>
            <mds-button
                [id]="'confirm-btn'"
                id="changeSiteStatusConfirmBtn"
                label="Confirm"
                (clickEvent)="saveDialog()"
                [color]="'primary'"
                [variant]="'filled'"
            >
            </mds-button>
        </div>
    </mds-dialog-actions>
</mds-dialog>
